// Module
var code = "<div class=\"h100\" ng-controller=\"VueRouterWrapperCtrl\" ng-cloak> <vue-component class=\"h100\" name=\"VueRouterWrapper\" router=\"router\" v-on-navigate=\"navigateTo\" v-on-create-template=\"createTemplate\" v-on-edit-template=\"editTemplate\"></vue-component> </div> ";
// Exports
module.exports = code;